/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['@media (max-width:767px){.body-content[_ngcontent-%COMP%]{padding-top:50px}}.nvd3[_ngcontent-%COMP%]   .nv-axis[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{stroke:#e5e5e5}.nvtooltip[_ngcontent-%COMP%]{font-size:15px;padding:5px 10px;font-family:johnston;user-select:none;background:hsla(0,0%,100%,.8);border:1px solid rgba(0,0,0,.5);border-radius:4px}.nvtooltip[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{padding:0 0 0 10px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9DbGllbnRBcHAvYXBwL2FwcC5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2FwcC9DbGllbnRBcHAvYXBwL2FwcC5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/ClientApp/app/app.component.css.shim.ngstyle.ts